import { Component, OnInit, ViewChild } from '@angular/core';
import { SalesPersonService } from '../../../services/sales-person.service';
import { gridPageRequest } from '../../../model/common/common.model';
import { SharedModule } from '../../../shared/shared.module';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { salesPerson, salesPersonGridResponse } from '../../../model/masters.model';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-salesperson-lookup',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './salesperson-lookup.component.html',
  styleUrl: './salesperson-lookup.component.scss'
})

export class SalespersonLookupComponent implements OnInit {

  constructor(private salespersonservice: SalesPersonService, public ref: DynamicDialogRef) { }
  @ViewChild('dt1') dt1: Table | undefined;

  ngOnInit(): void {
    this.getSalesperson();
  }

  loader: boolean = false;
  searchKey : any;

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 10,
    id: 0
  }

  result: salesPersonGridResponse = {
    salespersons: [],
    totalRecords: 0
  }

  getSalesperson() {
    this.salespersonservice.getAllSalesperson(this.pageRequest).subscribe({
      next: data => {
        this.result = data as salesPersonGridResponse;
        this.loader = false;
      },
      error: error => {
        this.loader = false;
        console.error(error);
      }
    })
  }

  SelectOption(event: any) {
    if(event?.data){
      this.ref.close(event?.data);
    }else{
      this.ref.close(event);
    }
  }

  loadSalesperson(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + event.rows + 5;
    this.getSalesperson();
  }

  searchSales(){
    if (!this.searchKey) {
      return;
    }
    this.salespersonservice.autoSearchSalesPerson(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.result.salespersons = data.map((salespersons: any) => {
            return {
              ...salespersons,
              salespersonImage: salespersons.salespersonImage ? `data:image/jpeg;base64,${salespersons.salespersonImage}` : './assets/no-image.jpg'
            };
          });
          if (this.dt1) {
            this.dt1.first = 0;
          }
          this.searchKey = undefined;
        } else {
          // console.log(data);
        }
      },
      (error: any) => {
        console.log(error);
      }
    );

  }

refreshData(): void {
  if (this.dt1) {
    this.dt1.first = 0;
  }
  this.getSalesperson();
}

}

